// src/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null); // "admin" | "coach" | "student"
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // Check admin first
        const adminDoc = await getDoc(doc(db, "admins", firebaseUser.uid));
        if (adminDoc.exists()) {
          setUser(firebaseUser);
          setUserRole("admin");
          setUserData(adminDoc.data());
        } else {
          // Then coach
          const coachDoc = await getDoc(doc(db, "coaches", firebaseUser.uid));
          if (coachDoc.exists()) {
            setUser(firebaseUser);
            setUserRole("coach");
            setUserData(coachDoc.data());
          } else {
            // Then student
            const studentDoc = await getDoc(doc(db, "students", firebaseUser.uid));
            if (studentDoc.exists()) {
              setUser(firebaseUser);
              setUserRole("student");
              setUserData(studentDoc.data());
            } else {
              setUser(null);
              setUserRole(null);
              setUserData(null);
            }
          }
        }
      } else {
        setUser(null);
        setUserRole(null);
        setUserData(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const canTeach = userRole === "admin" || userRole === "coach";
  const canManageStudents = userRole === "admin"; // admin-only: add students, add coaches

  return (
    <AuthContext.Provider value={{ user, userRole, userData, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}